export default {
  routeDetails: {
    routeDetails: 'Podrobnosti o trase',
    warnings: 'Výstrahy',
    routes: 'Trasy',
    route: 'Trasa',
    segments: 'Segmenty',
    segment: 'Segment',
    instructions: 'Instrukce',
    instruction: 'Instrukce',
    name: 'Name',
    selectRoute: 'Vybrat tuto trasu',
    selectedRoute: 'Vybraná trasa',
    gotoSegment: 'Přejít na segment',
    warningCodes: {
      1: 'Na některých silnicích mohou platit omezení',
      2: 'Na trase jsou zpoplatněné silnice',
      3: 'Na trase jsou vynechané úseky. Délka a dostupnost nemusí být správné',
      4: 'Minimálně jedna požadovaná informace navíc, ale není k dispozici'
    },
    routeOpacity: 'Neprůhlednost trasy'
  }
}
